import { useParams } from "react-router-dom";
import { atom, useAtom } from "jotai";
import { MemberPaymentType } from "../domain";

export const memberPaymentAtom = atom<MemberPaymentType | null>(null)
export const genericPaymentLinkIDAtom = atom<string | null>(null)

export const useMemberPayment = () => {
  const { paymentId } = useParams();
  const [memberPayment, setMemberPayment] = useAtom(memberPaymentAtom)
  const [genericPaymentLinkID, setGenericPaymentLinkID] = useAtom(genericPaymentLinkIDAtom)

  return { paymentId, memberPayment, setMemberPayment, genericPaymentLinkID, setGenericPaymentLinkID };
};

